export const config = {
  API: process.env.VUE_APP_API_URL,
  MAP_KEY: process.env.NODE_ENV === 'development' ? 'pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtpY2R1YTA0YW8zb2xzMzNkaDNxaTMifQ.LHbDy1LeUYXAgS7FJG-VOQ' : 'pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtpY2R1YTA0YW8zb2xzMzNkaDNxaTMifQ.LHbDy1LeUYXAgS7FJG-VOQ'
  // SEO_API: `http://api.vinchecker.com.dev11.vintagedev.com.ua`
}

const urlParams = new URLSearchParams(window.location.search)
const hasMdParam = urlParams.has('country') && urlParams.get('country') === 'md'

export const isMd = window.location.hostname.includes('md') || hasMdParam
